import { http } from "../../utils/config";

const logAPI = {
    getLogs: (params = {}) => {
        const {
            date = "",
        } = params;

        const queryParams = new URLSearchParams({
            date,
        });

        return http.get(`/api/v1/logs/view-daily-log?${queryParams}`);
    },

    getActions: () => {
        return http.get(`/api/v1/logs/actions`);
    },

    getLogActions: (params = {}) => {
        const {
            page = 1,
            per_page = 15,
            search = "",
            action = "",
            sort_by = "created_at",
            sort_order = "desc",
            from_date = '',
            to_date = '',
            is_read = ''
        } = params;

        const queryParams = new URLSearchParams({
            page: page.toString(),
            per_page: per_page.toString(),
            sort_by,
            sort_order,
            ...(search && { search }),
            ...(action && { action }),
            ...(from_date && { from_date }),
            ...(to_date && { to_date }),
            ...(is_read !== "" && { is_read })
        });

        return http.get(`/api/v1/logs/actions/view-daily-log?${queryParams}`);
    },

    getLoginAccount: () => {
        return http.get(`/api/v1/logs/actions/login-account`);
    },

    markAsRead: (ids = []) => {
        return http.post(`/api/v1/logs/actions/mark-as-read`, { ids });
    },

    markAllAsRead: () => {
        return http.post(`/api/v1/logs/actions/mark-as-read`);
    },
};


// Helper functions for handling API responses
export const actionsHelpers = {

  // Extract paginated list from API response
  extractActionList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        actioLogs: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
          nextPageUrl: data.next_page_url,
          prevPageUrl: data.prev_page_url
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },


};

// Error handling wrapper
export const withErrorHandling = (apiFunction) => {
    return async (...args) => {
        try {
            const response = await apiFunction(...args);
            return response;
        } catch (error) {
            console.error("API Error:", error);

            // Handle different types of errors
            if (error.response) {
                // Server responded with error status
                const { status, data } = error.response;
                switch (status) {
                    case 400:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 401:
                        throw new Error("Bạn cần đăng nhập để thực hiện thao tác này");
                    case 403:
                        throw new Error("Bạn không có quyền thực hiện thao tác này");
                    case 404:
                        throw new Error("Không tìm thấy thông tin");
                    case 422:
                        throw new Error(data.message || "Dữ liệu không hợp lệ");
                    case 500:
                        throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
                    default:
                        throw new Error(data.message || "Đã có lỗi xảy ra");
                }
            } else if (error.request) {
                // Network error
                throw new Error("Không thể kết nối đến server");
            } else {
                // Other error
                throw new Error(error.message || "Đã có lỗi xảy ra");
            }
        }
    };
};

// Wrapped API functions with error handling
export const logAPIWithErrorHandling = {
    getLogs: withErrorHandling(logAPI.getLogs),
    getActions: withErrorHandling(logAPI.getActions),
    getLogActions: withErrorHandling(logAPI.getLogActions),
    getLoginAccount: withErrorHandling(logAPI.getLoginAccount),
    markAsRead: withErrorHandling(logAPI.markAsRead),
    markAllAsRead: withErrorHandling(logAPI.markAllAsRead),
};

export default logAPI;
